export const environment = {
  production: true,
  host: 'https://admin.test.mytable.costa.it/api',
  constantMaxReservationsPerEvent: 1,
  domain: 'test.mytable.costa.it',
  firebaseConfig: {
    apiKey: "AIzaSyDaLViqGRHmL_xqozp_oM4OvyGRi_nwcpc",
    authDomain: "goreply-costa-myitalian-stage.firebaseapp.com",
    projectId: "goreply-costa-myitalian-stage",
    storageBucket: "goreply-costa-myitalian-stage.firebasestorage.app",
    messagingSenderId: "383377022476",
    appId: "1:383377022476:web:a46de49d776dcdbfef5829"
  },
  firebaseProvider : 'oidc.auth2-myitalian-stage'
};
